import { useCallback } from 'react';
import { useRequest } from './useRequest';
import { Marker, MarkerCreate } from '../types/marker';

export function useMarker() {
  const listRequest = useRequest<Marker[]>();
  const createRequest = useRequest<Marker>();
  const updateRequest = useRequest<Marker>();
  const deleteRequest = useRequest<void>();

  const fetchMarkers = useCallback(() => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/api/marcadores`;
    listRequest.execute(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createMarker = useCallback(async (data: MarkerCreate) => {
    await createRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/marcadores`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateMarker = useCallback(async (id: number, data: Partial<MarkerCreate>) => {
    await updateRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/marcadores/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    // Não chamar fetchMarkers() automaticamente aqui
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteMarker = useCallback(async (id: number) => {
    await deleteRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/marcadores/${id}`, {
      method: 'DELETE',
    });
    // Não chamar fetchMarkers() automaticamente aqui
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    // Estados para listagem
    markers: listRequest.data || [],
    listLoading: listRequest.loading,
    listError: listRequest.error,

    // Estados para operações de salvar (create/update)
    saveLoading: createRequest.loading || updateRequest.loading,
    saveError: createRequest.error || updateRequest.error,

    // Estados para operações de deletar
    deleteLoading: deleteRequest.loading,
    deleteError: deleteRequest.error,

    // Funções
    fetchMarkers,
    createMarker,
    updateMarker,
    deleteMarker,
  };
}